module.exports = __webpack_public_path__ + "img/comprehensive-overview.779f92e6.svg";